import styles from './main_history.module.css';
import { Link } from 'react-router-dom';

const projects = [
    ['2017.12–2018.03', 'SK하이닉스 GPU Docker 프로젝트'],
    ['2018.08–2018.10', '신한카드 빅데이터 통합분석 시스템'],
    ['2019.03–2019.07', '신한카드 초개인화 마케팅 분석 플랫폼'],
    ['2021.05–2021.06', 'LX Pantos Batch Template'],
    ['2021.06–2021.10', 'LG전자 GERP 경량화 프로젝트'],
];
const career = [
    ['2013.08–2014.08', '삼성전자 빅데이터 플랫폼 2.0 컨설팅'],
    ['2014.09–2016.05', '정보화진흥원 빅데이터 센터 컨설팅'],
];
const HistoryList = ({ items }) => (
    <ul className={styles.timeline}>
        {items.map(([period, title]) => <li key={title}><span className={styles.period}>{period}</span><span>{title}</span></li>)}
    </ul>
);

export default function MainHistory() {
    return (
        <section className={styles.section} aria-labelledby="company-overview-title">
            <div className={styles.overview}>
                <div className={styles.heading}>
                    <h2 id="company-overview-title">제이소프트웨어 주식회사</h2>
                    <p className={styles.summary}>서비스를 만들고,<br />기술의 경험을 나눕니다.</p>
                    <p className={styles.founded}>2017년 11월 설립</p>
                </div>
                <div className={styles.description}>
                    <p>금융·제조·물류 분야의 데이터 플랫폼과 업무 시스템 구축 경험을 바탕으로 고객사 앱 개발, 시스템 기능개선과 유지보수를 수행하는 소프트웨어 개발 전문기업입니다.</p>
                    <p>주말농장 서비스를 웹과 안드로이드에서 운영하며, 개발 현장의 경험을 실무 개발 교육으로 나누고 있습니다. 음성 인터페이스 SaaS를 기획·연구하고, R&D 과제 지원과 서비스 구현을 준비합니다.</p>
                    <p>자체 서비스 개발과 지식·문서 업무, 교육 콘텐츠 제작에 AI를 활용하며 업무 방식을 개선하는 AX(AI 전환)를 실천하고 있습니다.</p>
                    <p>우리는 요구사항 분석부터 개발, 데이터 정합성 검증, 테스트와 유지보수까지 프로젝트의 전 과정을 수행합니다.</p>
                </div>
            </div>
            <div className={styles.details}>
                <section className={styles.history} aria-labelledby="company-projects-title">
                    <h3 id="company-projects-title">회사 주요 수행실적</h3>
                    <HistoryList items={projects} />
                    <div className={styles.career}>
                        <h4>대표자 주요 경력 <span>법인 설립 이전</span></h4>
                        <HistoryList items={career} />
                    </div>
                    <Link className={styles.more} to="/portfolio?view=capabilities">사업영역과 기술 역량 보기 »</Link>
                </section>
                <section className={styles.activities} aria-labelledby="company-activities-title">
                    <h3 id="company-activities-title">현재 진행 중인 활동</h3>
                    <ul>
                        <li>주말농장 서비스 운영</li>
                        <li>고객사 앱 및 업무 시스템 개발</li>
                        <li>실무 개발 교육</li>
                        <li>음성 인터페이스 SaaS 기획·연구</li>
                        <li>AI 활용 개발 · 지식·문서 업무 효율화</li>
                    </ul>
                </section>
                <section className={styles.credentials} aria-labelledby="company-credentials-title">
                    <h3 id="company-credentials-title">등록 및 확인서 보유 현황</h3>
                    <ul>
                        <li>나라장터 소프트웨어사업자 등록</li>
                        <li>SW사업자 확인서</li>
                        <li>중소기업확인서 <span>소기업·소상공인</span></li>
                        <li>정보시스템개발서비스 직접생산확인증명서</li>
                        <li>정보시스템유지관리서비스 직접생산확인증명서</li>
                    </ul>
                </section>
            </div>
        </section>
    );
}
